import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { utcToHomeDate } from '../../utils/dateConvert';

class AwaitingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {

  }

  render() {

    return (

      <Table responsive striped>
        <thead>
          <tr>

            <th>Name</th>
            <th>Depot</th>
            <th>Last Reported</th>
            <th>Location</th>
            <th>SIM</th>
            <th>IMEI</th>


          </tr>
        </thead>
        <tbody>
          {this.props.awaitingList.map((list, index) => {
            return (
              <tr>
                <td>{list.assetName}</td>
                <td>{list.depotName}</td>
                <td>
                  {utcToHomeDate(list.lastReported)}
                </td>
                <td>
                  {list.location}
                </td>
                <td>
                  {list.sim}
                </td>
                <td>
                  {list.imei}
                </td>


              </tr>
            )
          })}

        </tbody>

      </Table>

    );
  }

}

export default AwaitingTable;
